import {
    TextProps as ChakraTextProps,
    Text as ChakraText,
} from '@chakra-ui/react';
import React from 'react';

export type TextProps = ChakraTextProps;

export const Text: React.FC<TextProps> = ({
    ...props
}) => (
    <ChakraText {...props} />
);
